import {Component, Input, OnInit} from '@angular/core';
import {ReportControl} from '../../report-builder/entities/report-control';
import {ReportControlEditorService} from '../report-control-editor.service';

@Component({
    selector: 'app-multi-line-text-field-renderer',
    templateUrl: './multi-line-text-field-renderer.component.html',
    styleUrls: ['./multi-line-text-field-renderer.component.scss'],
    standalone: false
})
export class MultiLineTextFieldRendererComponent implements OnInit {

  @Input() control: ReportControl;

  constructor(private editorService: ReportControlEditorService) { }

  ngOnInit(): void {
  }

  onTextReceived(text: string) {
    this.control.value += text;
    this.editorService.triggerEvent();
  }

  onValueChanges() {
    this.editorService.triggerEvent();
  }

}
